var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFactaLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90466 22.8045L11.0001 24L21.4999 18.0001V6.00017L19.4045 4.80469C15.8969 6.81219 12.3894 8.79713 8.90466 10.8046V15.6091C11.7061 14.0076 14.5076 12.4061 17.2863 10.8046V15.6091C14.4848 17.2106 11.6833 18.8121 8.88184 20.4136L8.90466 22.8045Z",
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69084 8.41349C8.19836 6.40597 11.6831 4.42102 15.1907 2.41351L10.9999 0L0.5 5.99995V17.9999L4.69084 20.3908C4.69084 16.3984 4.69084 12.4059 4.69084 8.41349Z",
    fill: "#F7F7F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactaLogoWhite);
export default __webpack_public_path__ + "static/media/facta-logo-white.de97460364e2d445609ee1b530ff7ba0.svg";
export { ForwardRef as ReactComponent };